import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Container } from '../Container.js';
export const IconBillard = forwardRef((props, ref) => _jsx(Container, {
  "data-testid": "IconBillard",
  viewBox: "0 0 24 24",
  ref: ref,
  ...props,
  children: _jsx("path", {
    fillRule: "evenodd",
    d: "M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0m-4-2a5 5 0 1 1-10 0 5 5 0 0 1 10 0m-4.06-2.84Q12.52 7.01 12 7q-.51 0-.93.16-.4.17-.64.47-.23.31-.23.76a1.4 1.4 0 0 0 .54 1.1q.25.21.56.37-.36.15-.65.37-.3.21-.47.51-.18.3-.18.7 0 .49.23.84t.69.54 1.1.18q.6 0 1.04-.2.45-.18.7-.54t.24-.85q0-.4-.18-.69-.19-.3-.5-.5a4 4 0 0 0-.7-.4q.31-.15.6-.34.26-.21.42-.47.16-.27.16-.62 0-.45-.23-.76a1.4 1.4 0 0 0-.63-.47M11 12.18a1 1 0 0 1-.33-.74q0-.3.14-.54t.4-.42q.28-.2.66-.34l.15.05q.4.14.69.32t.44.4.16.5q0 .48-.34.77t-.98.29q-.66 0-1-.29m.18-4.41q.3-.23.8-.23t.82.23q.3.22.3.64a1 1 0 0 1-.13.51q-.15.2-.39.37-.24.15-.56.28a5 5 0 0 1-.59-.28q-.26-.15-.41-.36a1 1 0 0 1-.15-.51q0-.42.3-.65"
  })
}));